import React from 'react'
import { useLocation } from 'react-router-dom';
import NavMenu from 'components/Common/NavMenu';
import Footer from 'components/Common/Footer';

const UserLayout = ({ children, profile, isNavbarHide, isFooterHide }) => {

    const { pathname } = useLocation();

    let isAllowFooter = false;
    if (!profile.isLoggedIn) {
        isAllowFooter = true;
    } else {
        isAllowFooter =
            !String(pathname).includes('/admin') &&
            !String(pathname).includes('/superadmin')
    };

    return (
        <div className='layout'>
            {!isNavbarHide && <NavMenu />}
            <div className={pathname.startsWith('/search-business-ai')
                ? 'main-content'
                : 'main-content-not-homepage'
            }>
                {children}
            </div>
            {isAllowFooter && <Footer />}
        </div>
    )
}

export default UserLayout